import ErrorMessage from '../../Elements/ErrorMessage';

// Mirrors OutsourcedFteIobConstants.IobGenerationDayOfMonth: the automated salary and bonus IOB
// generation runs on the first evaluation on/after this day each month (moved from the 1st on CD-5409).
export const IOB_GENERATION_DAY_OF_MONTH = 7;

// CD-5466: generation is asynchronous — the backend queues the request and returns immediately; the result
// (created invoice ids, warnings or errors) arrives later as an in-app popup notification, even if the user
// has left this page. This handler only acknowledges the queuing.
export function handleIobQueuedResponse(response) {
  if (!response) return;

  if (response.errors && response.errors.length > 0) {
    ErrorMessage.SetErrorMessage(response.errors.join('\n'));
    return;
  }

  ErrorMessage.SetNotification(
    response.queuedMessage || 'IOB generation has been queued. A notification will pop up when it finishes.'
  );
}

// Bonus generation is asynchronous for the same reason the salary generation is (CD-5466): only
// BambooHrApiService may reach BambooHR, so the request is queued and the outcome — invoiced shares, skip
// reasons, warnings — arrives later as an in-app popup notification. This handler only acknowledges the
// queuing.
export function handleBonusIobQueuedResponse(response) {
  if (!response) return;

  if (response.errors && response.errors.length > 0) {
    ErrorMessage.SetErrorMessage(response.errors.join('\n'));
    return;
  }

  ErrorMessage.SetNotification(
    response.queuedMessage || 'Bonus IOB generation has been queued. A notification will pop up when it finishes.'
  );
}

export function handleReverseIobResponse(response) {
  if (!response) return;

  if (response.errors && response.errors.length > 0) {
    ErrorMessage.SetErrorMessage(response.errors.join('\n'));
    return;
  }

  const parts = [];
  if (response.createdIobInvoiceId) {
    parts.push(`Created Reverse IOB Invoice #${response.createdIobInvoiceId}`);
  }
  if (response.warnings && response.warnings.length > 0) {
    parts.push(`Warnings: ${response.warnings.join(' | ')}`);
  }
  if (parts.length > 0) {
    ErrorMessage.SetNotification(parts.join('\n'));
  } else {
    ErrorMessage.SetNotification('Reverse IOB created.');
  }
}
